<template>
	<div  v-form="'back-bu-info'">
        <!-- 基本信息 -->
        <div class="base-item">
            <div class="small-title">基本信息</div>
            <div class="two">
                <div class="back-item">
                    <div class="back-title">BU名称</div>
                    <div class="back-wrap">
                        <el-input class="top-choose z-mid" rule="noVal" v-tar="sub.name" v-model="sub.name" placeholder="请输入BU名称">
                        </el-input>
                    </div>
                </div>
                <div class="back-item">
                    <div class="back-title">BU合伙人</div>
                    <div class="back-wrap text">{{sub.leader_name || "暂无" }}</div>
                </div>
            </div>
            <div class="back-item area">
                <div class="back-title">BU职责</div>
                <div class="back-wrap">
                    <textarea rule="reason describe_limit" v-arg="'BU职责描述'" v-tar="sub.description" v-model="sub.description" placeholder="请BU职责描述"></textarea>
                </div>
            </div>
            <!-- <input v-tar="idsStr" v-model="idsStr" v-show="false"> -->
        </div>

        <!-- 经营范围 -->
        <div class="base-item" >
            <div class="small-title">
                经营范围
                <el-checkbox v-model="sub_checkall"  @change="manageAll"></el-checkbox>
            </div>
            <el-checkbox-group v-model="sub.sub_tpl_ids" v-tar="sub_str" @change="manageCheck">
                <el-checkbox v-for="item in taskTpl" :key="item.id" :label="item.id">{{ item.tpl_name }}</el-checkbox>
            </el-checkbox-group>
        </div>

        <!-- 发布范围 -->
        <div class="base-item">
            <div class="small-title">
                发布范围
                <el-checkbox v-model="pub_checkall" @change="releaseAll"></el-checkbox>
            </div>
            <el-checkbox-group v-model="sub.pub_tpl_ids" v-tar="pub_str" @change="releaseCheck">
                <el-checkbox v-for="item in taskTpl" :key="item.id" :label="item.id">{{ item.tpl_name }}</el-checkbox>
            </el-checkbox-group>
        </div>


        <!-- 资产状况 -->
        <div class="base-item">
            <div class="small-title">奖金状况</div>
            <div class="text">
                <span v-for="item in bonus_list" :key="item.currency_id">{{ `${item.currency_name}：${item.current_currency_balance}` }}</span>
            </div>
        </div>

        <!-- 预算状况 -->
        <div class="base-item">
            <div class="small-title">预算状况</div>
            <div class="text">
                <div v-for="item in budget_list" :key="item.currency_id">
                    <span >{{ `${item.currency_name}：${item.currency_budget}(冻结：${item.currency_budget_frozen})` }}</span>
                    <span>预算完成率：{{ `${item.used_rate/100}%` }}</span>
                </div>
            </div>
        </div>

        <div class="btns">
            <div class="back-btn blue" :class="{disabled:!now_form.changeFlag}" @click="save">保存</div>
            <div class="back-btn" :class="{disabled:!now_form.changeFlag}" @click="cancel">取消</div>
        </div>
	</div>
</template>

<script>
    import { mapState } from "vuex";

	export default {
        props:['index','buId'],
		data(){
			return {
                now_form:{},
                data:{},
                sub:{
                    name:"",    //BU名称
                    leader_name:"",  //合伙人名称
                    description:"",   //bu描述

                    sub_tpl_ids:[],  //经营范围
                    pub_tpl_ids:[],  //发布范围
                },
                sub_checkall:false,  //经营范围  全选
                pub_checkall:false,  //发布范围  全选
			}
        },
        computed:{
            ...mapState(['taskTpl']),
            maxIds(){  //全选最大合集
                return this.taskTpl.map(item=>{
                    return item.id;
                });
            },
            sub_str(){  //经营范围 str
                return [...this.sub.sub_tpl_ids].sort().join(',');
            },
            pub_str(){  //发布范围 str
                return [...this.sub.pub_tpl_ids].sort().join(',');
            },

            bonus_list(){
                return this.data.bonusInfo;
            },
            budget_list(){
                return this.data.budgetInfo;
            },
        },

        created(){
            this.$func.getTaskTpl(true);
            this.fresh(this.index);
        },

		mounted(){
			this.now_form = this.$form.forms["back-bu-info"];
        },

        watch:{
            index(val){
                this.fresh(val);
            }
        },
        
		methods:{
            fresh(activeIndex){  //刷新页面判断
                if(activeIndex == 1){
                     this.getData();
                }
            },
            getData(){  //拉取bu数据
                let url = `api/admin/bu/update/info`;
                this.$http.get(url,{
                    params:{
                        bu_id:this.buId
                    }
                }).then(res=>{
                    if(res.status == 200){
                        console.log(res.res_data);
                        let bu = res.res_data.bu;
                        this.sub.name = bu.buName;
                        this.sub.description = bu.buDescription;
                        this.sub.leader_name = bu.partner && bu.partner.realName;
                        this.sub.sub_tpl_ids = bu.subTemplateIds?bu.subTemplateIds.split(",").map(id=>parseInt(id)):[];
                        this.sub.pub_tpl_ids = bu.pubTemplateIds?bu.pubTemplateIds.split(",").map(id=>parseInt(id)):[];

                        this.data = res.res_data;
                        this.manageCheck();
                        this.releaseCheck();
                        this.$form.init("back-bu-info");
                    }
                })
            },

            // ***多选功能

            manageAll(event){   //经营范围  全选
                this.sub.sub_tpl_ids = event.target.checked?[...this.maxIds]:[];
            },
            releaseAll(event){   //发布范围  全选
                this.sub.pub_tpl_ids = event.target.checked?[...this.maxIds]:[];
            },
            manageCheck(){  //经营范围 单选
                this.sub_checkall = this.sub.sub_tpl_ids.length === this.maxIds.length;
            },
            releaseCheck(){ //发布范围 单选
                this.pub_checkall = this.sub.pub_tpl_ids.length === this.maxIds.length;
            },

            // ***按钮操作
			save(){
				let res = this.$form.check("back-bu-info");
				if(!res){
					return;
                }
                this.$func.loading(true);
                let url = `api/admin/bu/update`;
                this.$http.post(url,{
                    bu_id:this.buId,
                    bu_name:this.sub.name,
                    bu_description:this.sub.description,
                    bu_sub_tpl_ids:this.sub.sub_tpl_ids.join(","),
                    bu_pub_tpl_ids:this.sub.pub_tpl_ids.join(","),
                }).then(res=>{
                    if(res.status == 200){
                        this.getData();
                        this.successTip("保存成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.$func.loading(false);
                    this.errorTip("出错了");
                })
			},
			cancel(){
                this.getData();
			},
		}
	}
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";
    
    .base-item{
        .text span{
            display: inline-block;
            margin-right: 40px;
            font-size:12px;
        }
    }

    .back-item{
        &:after{
            content:"";
            display: block;
            clear: both;
        }
        .back-title{
            float:left;
        }
        .back-wrap{
            float:left;
        }

    }

    .two .back-item{
        display:inline-block;
        &+.back-item{
            margin-left: 30px;
        }
    }
    
    .btns{
        font-size:0;
        margin-top:40px;
        .back-btn{
            margin-right:15px;
        }
    }

    .small-title{
        font-size: 12px;
        font-weight: 600;
        padding-left:5px; 
        border-left:2px solid #a4e6f2;
        margin: 20px 0;
    }
</style>





// WEBPACK FOOTER //
// detail-info.vue?bb288b76